<template>
  <div class="card">
    <div class="print">
      <div class="docdate text-capitalize">
        {{ offerTypeText }} indicatief uitkeringsschema {{ today }}
      </div>
      <img id="db-logo" src="../../../assets/db/DB-logo1.svg" />

      <p v-if="offerType == 1 || offerType == 4">
        Hieronder staat het verwachte verloop van de uitkeringen op jaarbasis. U ziet dat bij de
        {{ offerTypeText }} de geschatte uitkering direct hoog start om vervolgens een aantal
        jaren erna mooi op te lopen. Na deze ingebouwde verhoging zijn de uitkeringen stabiel en
        weer op het niveau van de eerste uitkering.
      </p>
      <p v-else>
        Hieronder staat het verwachte verloop van de uitkeringen op jaarbasis. U ziet dat na de
        start de geschatte uitkeringen met het Neutrale en het Optimistische verloop mooi oplopen.
        In het Pessimistische geval dalen de uitkeringen.
      </p>

      <div class="graph">
        <template v-if="offerType == 0">
          <GChart
            :settings="{ packages: ['corechart'], language: 'nl-nl' }"
            :data="results4"
            :options="options1"
            type="ComboChart"
          />
        </template>
        <template v-if="offerType == 1 || offerType == 4">
          <GChart
            :settings="{ packages: ['corechart'], language: 'nl-nl' }"
            :data="results3"
            :options="options1"
            type="ComboChart"
          />
        </template>
      </div>
      <h3>Direct profijt of later meer uitkeren?</h3>
      <template v-if="offerType == 1 || offerType == 4">
        <p>
          De {{ offerTypeText }} werkt anders dan de traditionele uitkerende
          beleggingslijfrente.
          Een belangrijk voordeel is dat de {{ offerTypeText }} zo is samengesteld dat deze
          direct start met een hogere uitkering en daarna zelfs nog wat oploopt. Daardoor sluit
          deze beter aan bij de behoefte om in het begin van het pensioen hogere uitkeringen te
          ontvangen. De traditionele beleggingslijfrente doet dat niet. Die begint laag en loopt
          op, om pas jaren later op hetzelfde niveau te komen.
        </p>
      </template>
      <template v-if="offerType == 0">
        <p>
          De traditionele beleggingslijfrente, waarvoor u heeft gekozen, begint laag en loopt
          daarna op. Dat kan van pas komen wanneer u de eerste jaren geen behoefte heeft aan een
          hoge uitkering, maar op latere leeftijd de hogere uitkering beter van pas komt. Dat
          kan fiscaal of bij vererven beter uitkomen.
        </p>
        <p>
          Bij Doelbeleggen hebben we ook de mogelijkheid om in het begin meer uit te laten
          keren. Deze uitkerende lijfrente heet Leefrente en werkt anders dan de
          traditionele uitkerende beleggingslijfrente. Neem voor vragen over Leefrente
          contact met ons op, wij helpen u graag verder.
        </p>
      </template>
      <div class="graph" v-if="duration != 5">
        <GChart
          :settings="{ packages: ['corechart'], language: 'nl-nl' }"
          :data="results2"
          :options="options2"
          type="ComboChart"
        />
      </div>

    </div>
    <div class="pagefooter">
      &copy; info@doelbeleggen.nl - 020 555 0055 - Dorpsstraat 34 - 1182 JE Amstelveen
    </div>
    <div class="pagenumber" />
    <div class="break" />
  </div>
</template>

<script>
export default {
  name: 'leefrentePageCharts',
  props: {
    duration: {
      type: Number,
      required: true,
      default: 10,
    },
    offerType: {
      type: Number,
      required: true,
      default: 1,
    },
    charts: {
      type: Object,
      required: true,
    },
    profile: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      today: new Date().toLocaleString('nl-NL').split(' ')[0].replace(/\//g, '-'),
      options1: {
        backgroundColor: { fill: 'transparent' },
        height: 250,
        legend: { position: 'top' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 55,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          format: 'short',
          textStyle: { fontSize: 13 },
          gridlines: { color: '#eee' },
        },
        vAxis: {
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: { type: 'line', color: '#c1272d' },
          1: { type: 'line', color: '#67bf00' },
          2: { type: 'line', color: '#000066' },
        },
      },
      options2: {
        backgroundColor: { fill: 'transparent' },
        height: 300,
        legend: { position: 'top' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 55,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          format: 'short',
          textStyle: { fontSize: 13 },
          gridlines: { color: '#eee' },
        },
        vAxis: {
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: {
            type: 'line', lineWidth: 0, visibleInLegend: false, tooltip: false,
          },
          1: { type: 'line', color: '#67bf00' },
          2: { type: 'line', color: '#000066' },
        },
      },
    };
  },
  computed: {
    offerTypeText() {
      if (this.offerType === 1) {
        return 'Leefrente';
      }
      if (this.offerType === 4) {
        return 'netto lijfrente';
      }
      return 'uitkerende lijfrente';
    },
    results() {
      return [this.getCols()].concat(this.charts.chart0);
    },
    results2() {
      return [this.getCols2()].concat(this.charts.chart2);
    },
    results3() {
      return [this.getCols3()].concat(this.charts.chart3);
    },
    results4() {
      return [this.getCols4()].concat(this.charts.chart4);
    },
    results5() {
      return [this.getCols4()].concat(this.charts.chart5);
    },
    results6() {
      return [this.getCols5()].concat(this.charts.chart6);
    },
  },
  methods: {
    getCols() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      // cols.push({
      //   type: 'number',
      //   label: 'U-Rendement',
      // });
      cols.push({
        type: 'number',
        label: 'Gouden handdruk',
      });
      cols.push({
        type: 'number',
        label: 'Traditionele uitkerende lijfrente',
      });
      return cols;
    },
    getCols2() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'U-Rendement',
      });
      cols.push({
        type: 'number',
        label: this.offerType === 0 || this.offerType === 1 ? 'Leefrente' : 'Netto lijfrente',
      });
      cols.push({
        type: 'number',
        label: 'Traditionele uitkerende lijfrente',
      });
      return cols;
    },
    getCols3() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'Pessimistisch (-2%)',
      });
      cols.push({
        type: 'number',
        label: `Neutraal (${this.profile}%)`,
      });
      cols.push({
        type: 'number',
        label: 'Optimistisch (8%)',
      });
      return cols;
    },
    getCols4() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'Pessimistisch (-2%)',
      });
      cols.push({
        type: 'number',
        label: `Neutraal (${this.profile}%)`,
      });
      cols.push({
        type: 'number',
        label: 'Optimistisch (8%)',
      });
      return cols;
    },
    getCols5() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'Zeer defensief',
      });
      cols.push({
        type: 'number',
        label: 'Defensief',
      });
      cols.push({
        type: 'number',
        label: 'Neutraal',
      });
      cols.push({
        type: 'number',
        label: 'Offensief',
      });
      cols.push({
        type: 'number',
        label: 'Zeer offensief',
      });
      return cols;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/_paper.scss";
</style>
